<template>
  <div class="a-list">
    <div class="radish-actions" v-if="showActions"><slot name="actions"></slot></div>
    <div class="a-list-head" v-if="checkable">
      <div><input type="checkbox" v-model="isCheckedAll" @change="onCheckAll" /> 全选</div>
    </div>
    <div class="a-list-layout" :style="layoutStyle" v-on:scroll="onScroll" ref="scroller">
      <div v-if="ready" class="a-list a-list-body">
        <div v-for="(item, index) in displayData" :key="'item' + start + index" class="a-list-row">
          <div class="a-list-col a-list-col-flex" style="width:15%">
            <div>
              <div class="a-list-num">{{ start + index + 1 }}</div>
              <div v-if="checkable" class="a-list-check">
                <input type="checkbox" v-model="displayData[index].checkedRow" @change="onCheckOne(index)" />
              </div>
              <div>
                <el-tag
                  v-if="item.意向"
                  :type="yiType(item.意向)"
                  size="mini"
                  style="margin:5px 0 0 5px;height:40px;text-align:center"
                >
                  意向<br />{{ item.意向 }}
                </el-tag>
              </div>
            </div>
            <div>
              <div class="a-list-col-item">
                <span :id="`操作${item._id}`" class="a-link" @click="onClickSetting(item)">
                  <i class="el-icon-setting"></i>
                </span>
                <span style="margin: 0 3px 0 5px;">
                  <span class="a-link" @click="onClickName(item)">{{ item.姓名 }}</span>
                  <span v-if="!item.手机" class="cc-icon cc-icon-g" style="margin-right: 3px;">c</span>
                </span>
                <span v-if="!item.附件" style="font-size:14px"><i class="el-icon-document"></i><span>0</span></span>
                <span v-else :id="`附件${item._id}`" class="a-link" @click="onClickDocument(item)">
                  <i class="el-icon-document"></i><span>{{ item.附件 }}</span>
                </span>
                <span style="margin: 0 5px;font-weight:500;position: relative;top: -1px;">|</span>
                <span class="a-link" @click="onClickCompany(item.公司)">{{ item.公司 }}</span>
              </div>
              <div class="a-list-col-item">
                <span v-if="item.性别" class="a-list-col-title">{{ item.性别 }} </span>
                <span v-if="item.地域" class="a-list-col-title">
                  {{ item.地域 instanceof Array ? item.地域.join(' ') : item.地域 }}
                </span>
                <span v-if="item.出生年月" class="a-list-col-title">{{ item.出生年月 }}</span>
              </div>
              <div class="a-list-col-item">
                <span v-if="item.职级" class="a-tag">职级:{{ item.职级 }}</span>
                <span v-if="item.业绩" class="a-tag">业绩:{{ item.业绩 }}</span>
                <span v-if="item.平台" class="a-tag">平台:{{ item.平台 }}</span>
                <el-tag v-if="item.长期意向" :type="yiType(item.长期意向)" size="mini" style="cursor:pointer"
                  >长意:{{ item.长期意向 }}</el-tag
                >
              </div>
              <div v-if="item.职能模块" class="a-list-col-item">
                <div v-for="(zhi, k) in item.职能模块" :key="k" class="a-tag">{{ zhi }}</div>
              </div>
              <div v-if="item.细分职能" class="a-list-col-item">
                <div v-for="(zhi, k) in item.细分职能" :key="k" class="a-tag">{{ zhi }}</div>
              </div>
              <div v-if="type === 'radish'" class="a-list-col-item">
                <span class="radish-btn radish-btn-primary" @click="onIntoProject(item)">加入项目</span>
                <span class="radish-btn radish-btn-primary" @click="onUploadCv(item)">上传简历</span>
              </div>
              <div
                v-else-if="type === 'radish-pro' && item.状态 && (item.状态.tag == '已推荐' || item.状态.tag == '面试')"
                class="a-list-col-item"
              >
                <span class="radish-btn radish-btn-primary" @click="onInterview(item)">安排面试</span>
                <span class="radish-btn radish-btn-primary" @click="onEliminate(item)">淘汰</span>
              </div>
            </div>
          </div>
          <div class="a-list-col" style="width:40%">
            <table>
              <th><td class="a-list-col-title" colspan="5">工作经历</td></th>
              <template v-if="item.任职经历">
                <tr v-for="(exp, k) in item.任职经历" :key="k" v-show="k < 3 || (k >= 3 && item._id == noExpMoreItem)">
                  <td width="80px">{{ exp.起始时间 }}</td>
                  <td width="80px">{{ exp.结束时间 }}</td>
                  <td>{{ exp.公司 }}</td>
                  <td>{{ exp.部门 }}</td>
                  <td>{{ exp.目前职位 }}</td>
                </tr>
              </template>
              <tr>
                <td colspan="5">
                  <div v-show="item.任职经历 && item.任职经历.length > 3 && noExpMoreItem != item._id"
                    class="a-link a-list-col-more"
                    @click="noExpMoreItem = item._id">
                    更多
                  </div>
                </td>
              </tr>

              <th><td class="a-list-col-title" colspan="5">教育经历</td></th>
              <template v-if="item.expEdu">
                <tr
                v-for="(exp, k) in item.expEdu"
                :key="exp._id"
                v-show="k < 3 || (k >= 3 && item._id == noEduMoreItem)"
              >
                <td width="80px">{{ exp.起始时间 }}</td>
                <td width="80px">{{ exp.结束时间 }}</td>
                <td>{{ exp.学校 }}</td>
                <td>{{ exp.专业 }}</td>
                <td>{{ exp.学历 }}</td>
              </tr>
              </template>
              <tr>
                <td colspan="5">
                  <div v-show="item.expEdu && item.expEdu.length > 3 && noEduMoreItem != item._id"
                    class="a-link a-list-col-more"
                    @click="noEduMoreItem = item._id">
                    更多
                  </div>
                </td>
              </tr>
            </table>
          </div>
          <div v-if="item.沟通日志 && item.沟通日志.length > 190" class="a-list-col" style="width:20%">
            <div class="a-list-col-title">沟通记录</div>
            <div class="a-list-col-content">{{ dotdot(item) }}</div>
            <div v-if="noDotMoreItem != item._id" class="a-link a-list-col-more" @click="noDotMoreItem = item._id">
              更多
            </div>
          </div>
          <div v-else class="a-list-col" style="width:20%">
            <div class="a-list-col-title">沟通记录</div>
            <div class="a-list-col-content">{{ item.沟通日志 }}</div>
          </div>
          <div class="a-list-col" style="width:25%">
            <div class="a-list-col-title">项目</div>
            <table>
              <tr>
                <td>状态</td>
                <td>客户公司</td>
                <td>部门</td>
                <td>项目名称</td>
              </tr>
              <tr
                v-for="(pro, i) in item.projects"
                :key="pro._id"
                v-show="i < 4 || (i >= 4 && item._id == noProMoreItem)"
              >
                <td>
                  <span v-if="pro.pid == item.pid">* </span>
                  <span v-if="pro.状态" class="a-tag" style="cursor:pointer" @click="onClickStatus({pid: pro.pid, rid: (item.rid || item._id), 姓名: item.姓名})">{{ pro.状态.tag }}{{ pro.状态 && pro.状态.detail ? ':'+pro.状态.detail : '' }}</span>
                  <span v-else>已加入</span>
                </td>
                <td>
                  <span class="a-link" @click="onClickCompany(pro.客户公司)">{{ pro.客户公司 }}</span>
                </td>
                <td>{{ pro.部门 }}</td>
                <td>
                  <a class="a-link" :href="`#/project20/${pro.pid}`" target="_blank">{{ pro.项目名称 }}</a>
                </td>
              </tr>
            </table>

            <div
              v-show="item.projects && item.projects.length > 4 && noProMoreItem != item._id"
              class="a-link a-list-col-more"
              @click="noProMoreItem = item._id"
            >
              更多
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    type: {
      type: String,
      default: 'radish',
    },
    data: {
      type: Array,
      default: [],
    },
    checkable: {
      type: Boolean,
      default: true,
    },
    height: {
      type: Number,
    },
    activeRowId: {
      type: String,
    },
    start: {
      type: Number,
      default: 0,
    },
    showActions: {
      type: Boolean,
      default: true,
    },
    onClickName: {
      type: Function,
      default: function() {},
    },
    onClickCompany: {
      type: Function,
      default: function() {},
    },
    onClickSetting: {
      type: Function,
      default: function() {},
    },
    onClickDocument: {
      type: Function,
      default: function() {},
    },
    onIntoProject: {
      type: Function,
      default: function() {},
    },
    onUploadCv: {
      type: Function,
      default: function() {},
    },
    onInterview: {
      type: Function,
      default: function() {},
    },
    onEliminate: {
      type: Function,
      default: function() {},
    },
    onClickStatus: {
      type: Function,
      default: function() {},
    },
  },
  data: function() {
    return {
      ready: false,
      tableData: [],
      displayData: [],
      isCheckedAll: false,
      shiftKeyPressed: false,
      lastCheckIndex: '',
      noDotMoreItem: '',
      noProMoreItem: '',
      noExpMoreItem: '',
      noEduMoreItem: '',
    }
  },
  computed: {
    layoutStyle: function() {
      if (this.height) {
        return { height: this.height + 'px' }
      }
    },
  },
  methods: {
    onCheckAll: function() {
      this.tableData = this.tableData.map(dt => {
        dt.checkedRow = this.isCheckedAll
        return dt
      })
    },
    onCheckOne: function(index) {
      if (this.lastCheckIndex !== '') {
        if (
          this.shiftKeyPressed &&
          this.tableData[index].checkedRow == this.tableData[this.lastCheckIndex].checkedRow
        ) {
          const big = Math.max(this.lastCheckIndex, index)
          const small = Math.min(this.lastCheckIndex, index)
          this.tableData = this.tableData.map((dt, i) => {
            if (i >= small && i <= big) {
              dt.checkedRow = this.tableData[index].checkedRow
            }
            return dt
          })
        }
      }
      this.lastCheckIndex = index
    },
    getChecked: function() {
      return this.tableData.filter(dt => {
        return dt.checkedRow
      })
    },
    onScroll: function() {
      this.setDisplay()
    },
    setDisplay: function(force) {
      if (force || this.displayData.length < this.tableData.length) {
        let sTop = this.$refs.scroller.scrollTop
        this.ready = false
        this.tableData = this.data
        let dtLen = this.displayData.length
        if (force || sTop > (dtLen - 20) * 60) {
          this.displayData = this.tableData.slice(0, dtLen + 20)
        }
        this.isCheckedAll = false
        this.ready = true
      }
    },
    dotdot(item) {
      if (item._id == this.noDotMoreItem) return item.沟通日志
      return item.沟通日志.substr(0, 190) + '...'
    },
    yiType(yi) {
      if (yi == 'Y') return 'danger'
      if (yi == 'N') return 'warning'
      return ''
    },

    reset: function() {
      this.ready = false
      this.isCheckedAll = false
      this.tableData = this.data
      this.displayData = this.tableData.slice(0, 50)
      this.ready = true
      this.$refs.scroller.scrollTop = 0
    },
  },
  created() {
    this.shiftKeyDown = e => {
      if (e.key === 'Shift') {
        return (this.shiftKeyPressed = true)
      }
    }
    this.shiftKeyUp = e => {
      if (e.key === 'Shift') {
        return (this.shiftKeyPressed = false)
      }
    }
    document.addEventListener('keydown', this.shiftKeyDown)
    return document.addEventListener('keyup', this.shiftKeyUp)
  },
  destroyed() {
    document.removeEventListener('keydown', this.shiftKeyDown)
    return document.removeEventListener('keyup', this.shiftKeyUp)
  },
}
</script>
<style>
.a-list-head {
  padding: 3px 5px;
  border-bottom: 1px solid #ebeef5;
}
.a-list-layout {
  position: relative;
  width: 100%;
  overflow: auto;
}
.a-list-row {
  display: flex;
  min-height: 60px;
  padding: 5px 0;
  margin-top: 5px;
  border: 1px solid #ebeef5;
  background-color: #fff;
  overflow: hidden;
  color: #303133;
  box-shadow: 0 0 2px 0 rgba(0, 0, 0, 0.1);
}
.a-list-num {
  width: 50px;
  text-align: center;
  flex-shrink: 0;
  padding-top: 5px;
}
.a-list-check {
  width: 50px;
  text-align: center;
  flex-shrink: 0;
  padding-top: 5px;
}
.a-list-col {
  padding: 0 8px;
  border-right: 1px dotted #ebeef5;
}
.a-list-col-flex {
  display: flex;
  padding-left: 0;
}
.a-list-col-more {
  text-align: right;
}
.a-list-col table {
  width: 100%;
}
.a-list-col-item {
  padding: 3px 0;
}
.a-list-col-item .a-link {
  font-size: 14px;
}
.a-list-col-item .el-tag {
  height: auto;
  margin-right: 5px;
}
.a-list-col-item .a-tag {
  margin: 0 5px 2px 0;
}
.a-list-col table > tr > td {
  color: #909399;
  padding: 0 5px;
}
.a-list-col-title {
  color: #000;
  font-weight: bold;
}
</style>
